"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OldCallbackBanner = require("./OldCallbackBanner");
Object.keys(_OldCallbackBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OldCallbackBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OldCallbackBanner[key];
    }
  });
});
var _OldCallbackBannerSuccess = require("./OldCallbackBannerSuccess");
Object.keys(_OldCallbackBannerSuccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OldCallbackBannerSuccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OldCallbackBannerSuccess[key];
    }
  });
});